import { render, staticRenderFns } from "./ExpireHeader.vue?vue&type=template&id=77f7b3b4&scoped=true&"
import script from "./ExpireHeader.vue?vue&type=script&lang=js&"
export * from "./ExpireHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExpireHeader.vue?vue&type=style&index=0&id=77f7b3b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7b3b4",
  null
  
)

export default component.exports